
import Services from './base-services'

const service = new Services('genders')

export default {
  listFromSuite: () => {
    return service.suiteOperation(() => service.get('list'))
  }
}
